<template>
  
  <div style="width:770px;marin:0 auto;margin-top:10px;margin-left:10px;">

   
         <el-form ref="form" :model="form" label-width="120px" v-loading="loading" :rules="rules">
            <div class="d-flex">
             <el-form-item :label="$t('tableText.알본사선택')" v-if="this.sitetype=='4' && this.aid=='admin' "  class="mb-0 formItem2" >
              <el-select v-model="form.admin_id" size="mini" style="width: 100px;margin-left: -30px;" filterable>
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
              
            </el-form-item>

             <el-form-item :label="$t('tableText.마스터선택')" v-if="!this.bubontop && this.sitetype=='4'"  class="mb-0 formItem2 ml-2">
              <el-select v-model="form.boss" :placeholder="$t('status.선택')" size="mini" prop="boss" style="width: 120px;margin-left: -40px;" filterable>
               <el-option
                      v-for="item in bubonlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
              <span class="text-danger ml-2"></span>
            </el-form-item>
          </div>
             <table class="table table-bordered myTable">
               
                <tr>
                  <td width="50%">
                     <el-form-item :label="$t('tableText.본사이름')" prop="agent_name" class="mb-0 formItem">
                        <el-input v-model="form.agent_name"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0 formItem">
                      <el-input v-model="form.mem_id"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('tableText.사용자암호')" :prop="editIndex===-1 ? 'mem_pw' :'empty'" class="mb-0 formItem">
                        <el-input v-model="form.mem_pw"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.닉네임')" prop="mem_name" class="mb-0 formItem">
                      <el-input v-model="form.mem_name"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <template v-if="(this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4') && this.power==='1'">
                <tr>
                  <td>
                    <el-form-item :label="$t('msg.파워볼일반')" class="mb-0 formItem" prop="event_loing_recom">
                      <el-input v-model="form.event_loing_recom"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.파워볼조합')" class="mb-0 formItem" prop="event_loing_group_recom">
                      <el-input v-model="form.event_loing_group_recom"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <!--<tr>
                  <td>
                   <el-form-item label="사다리 일반" class="mb-0 formItem" prop="event_loing_recom_s">
                      <el-input v-model="form.event_loing_recom_s"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item label="사다리 조합" class="mb-0 formItem" prop="event_loing_group_recom_s">
                      <el-input v-model="form.event_loing_group_recom_s"></el-input>
                    </el-form-item>
                  </td>
                </tr>-->
                </template>
                <template v-if="this.bg==='1' ">
                <tr>
                  <td>
                    <el-form-item :label="$t('msg.파워볼일반보글')" class="mb-0 formItem" prop="event_loing_recom1">
                        <el-input v-model="form.event_loing_recom1"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.파워볼조합보글')" class="mb-0 formItem" prop="event_loing_group_recom1">
                      <el-input v-model="form.event_loing_group_recom1"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                    <el-form-item :label="$t('msg.사다리일반보글')" class="mb-0 formItem" prop="event_loing_recom_s1">
                      <el-input v-model="form.event_loing_recom_s1"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.사다리조합보글')" class="mb-0 formItem" prop="event_loing_group_recom_s1">
                      <el-input v-model="form.event_loing_group_recom_s1"></el-input>
                    </el-form-item>
                  </td>
                </tr>
              </template>
              <template v-if="this.sitetype==='4'">
                <tr>
                  <td>
                    <el-form-item :label="$t('msg.카지노롤링')" class="mb-0 formItem" prop="event_loing_recom_e">
                      <el-input v-model="form.event_loing_recom_e"></el-input>
                    </el-form-item>
                   </td>
                  <td>
                    <el-form-item :label="$t('msg.슬롯롤링')" class="mb-0 formItem" prop="event_loing_recom_slot">
                      <el-input v-model="form.event_loing_recom_slot"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                  <template v-if="this.rosing==='1'">
                     <tr>
                  <td colspan="2">
                     <div class="d-flex" style="margin-top:0.5rem">
                     <el-form-item :label="$t('msg.바카라루징')" prop="pc_e" class="mb-0 bl">
                        <el-input v-model="form.pc_e"></el-input>
                      </el-form-item>
                       <el-form-item :label="$t('msg.슬롯루징')" prop="pc_slot" class="mb-0 bc">
                      <el-input v-model="form.pc_slot"></el-input>
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.파루징')" v-if="this.power==='1'" prop="pc_p" class="mb-0 bc-ml">
                      <el-input v-model="form.pc_p"></el-input>
                    </el-form-item>
                    </div>
                  </td>
                </tr>
              </template>
              </template>
                <tr>
                  <td>
                     <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem">
                      <el-input v-model="form.mem_hp"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem">
                      <el-input v-model="form.mem_bankcode"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem">
                        <el-input v-model="form.mem_banknum"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.예금주')" class="mb-0 formItem" prop="mem_bankname">
                      <el-input v-model="form.mem_bankname"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item :label="$t('tableText.출금비번')" class="mb-0 formItem" :prop="editIndex===-1 ? 'mem_jumin' :'empty'">
                        <el-input v-model="form.mem_jumin"></el-input>
                      </el-form-item>
                  </td>
                  <td></td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('tableText.회수가능')"  v-if="this.sitetype=='4'" class="mb-0 formItem" prop="recy">
                        <el-radio-group v-model="form.recy" class="mt-2">
                          <el-radio label="1">on</el-radio>
                          <el-radio label="0">off</el-radio>
                        
                        </el-radio-group>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.상태')"  class="mb-0 formItem">
                      <el-select v-model="form.status" size="mini">
                           <el-option
                                  v-for="item in bubonOptlist"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                    </el-form-item>
                  </td>
                </tr>

            
              </table>


          </el-form>
         <div class="d-flex" style="justify-content:center">
              <el-button @click="shopClose">{{$t('msg.취소')}}</el-button> 
            <el-button type="primary" @click="submit" :disabled="disabled">{{$t('msg.확인')}}</el-button>
         </div> 
          
  </div>
</template>
<script>
 
  export default{
     components: {
     
      
    
    },
    props:{
      //接收父组件传来的id值
      info:{
        type:Object,
        default:()=>{
          return {}
        }
      },
       layerid:{
        type:String,
        default:""
      },
         idx:{
        type:Number,
        default:""
      },
     eindex:{
        type:Number,
        default:""
      },
      
    },
    computed: {
          
          
            
        },
      data(){
        return{
            bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
            disabled:false,
              adminlist:[{
                label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
          form:{
            pc_p:'',
            pc_e:'',
            pc_slot:'',
            recy:'1',
           admin_id:'',
            agent_name:'',
            regcode:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
             boss:'',
            event_loing_recom:'0',
            event_loing_recom_s:'0',
            event_loing_group_recom:'0',
            event_loing_group_recom_s:'0',

             event_loing_recom1:'0',
            event_loing_recom_s1:'0',
            event_loing_group_recom1:'0',
            event_loing_group_recom_s1:'0',

            event_loing_recom_e:'',
            event_loing_recom_slot:'',
            mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
            
            status:'1',
          },
           bonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],

           bubonOptlist:[{
                label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
            zerocclist:[
            {
              label: this.$i18n.t("newAdd.없음"),
              value: '0',
            },
             {
              label: "하나",
              value: '1',
            }, {
              label: "두개",
              value: '2',
            }
            ],
          zerocc:'0',
          pi:false,
          editIndex:-1,
          bubontop:false,
           mins:'1',
          maxs:'30',
          back_id:'',
          boss:'',
          tips:'',
          newDate:'',
          v:'',
           domain:window.sessionStorage.getItem('domain'),
           admin_id:window.sessionStorage.getItem('admin_id'),
           power:window.sessionStorage.getItem('power'),
            sitetype:window.sessionStorage.getItem('sitetype'),
            rosing:window.sessionStorage.getItem('rosing'),
            bg:window.sessionStorage.getItem('bg'),
            aid:window.sessionStorage.getItem('admin_id'),
           sim:window.sessionStorage.getItem('sim'),
            loading:false,
              rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_slot:[{ required: true, message: '', trigger: 'blur'}],
                   recy:[{ required: true, message: '', trigger: 'blur'}],
                  shop_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  reg_code:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                  boss:[{ required: true, message: '', trigger: 'blur'}],
                  pc_slot:[{ required: true, message: '', trigger: 'blur'}],
                  pc_e:[{ required: true, message: '', trigger: 'blur'}],
                  bon_id:[{ required: true, message: '', trigger: 'blur'}],
                },
              
         
           
           
           
          
        }
      },
      created() {
         // this.info.id父组件传给子组件的id值
        
         console.log(this.info.id)
         this.fetchManage();
        

          
             
    },
    
      methods:{
        submit(){
             
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
           
            
                 this.disabled = true
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/bon_up',
                        data:{
                       agent_name:this.form.agent_name,
                          regcode:this.form.regcode,
                          boss:this.form.boss,
                          mem_pw:this.form.mem_pw,
                          mem_name:this.form.mem_name,
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                          event_loing_recom:this.form.event_loing_recom,
                          event_loing_recom_s:this.form.event_loing_recom_s,
                          event_loing_group_recom:this.form.event_loing_group_recom,
                          event_loing_group_recom_s:this.form.event_loing_group_recom_s,

                           event_loing_recom1:this.form.event_loing_recom1,
                          event_loing_recom_s1:this.form.event_loing_recom_s1,
                          event_loing_group_recom1:this.form.event_loing_group_recom1,
                          event_loing_group_recom_s1:this.form.event_loing_group_recom_s1,




                           event_loing_recom_e:this.form.event_loing_recom_e,
                          event_loing_recom_slot:this.form.event_loing_recom_slot,
                           mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                         
                          status:this.form.status,
                           recy:this.form.recy,
                          pc_slot:this.form.pc_slot,
                           pc_p:this.form.pc_p,
                          pc_e:this.form.pc_e
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                            message:response.data.msg,
                            type: 'success'
                          });
                               //console.log(this.form);
                               this.$parent.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                              
                              this.$layer.close(this.layerid)

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
            
            })
              
            
        },
        reConfirm(){
               let token=window.sessionStorage.getItem('user');

               if(this.form.mem_id=='')
               {
                    this.$message.error('id error')
                    return;
               }
               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/id_check',
                    data:{
                       mem_id:this.form.mem_id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                         
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
         openShopModel(id){

          if(id=='합계')
          {
             return;
          }

           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                //layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1100px','600px'],
           
        });
        
        },

    
        fetchManage(){
        
           let token=window.sessionStorage.getItem('user');
          
          
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/mstlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label= this.$i18n.t("msg.마스터없음")
            obj.value=''
            newids.push(obj); 

           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.code
            obj.value=item.code
            newids.push(obj);            
           });

           this.bubonlist=newids


            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })



         



             this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bon?id='+this.idx,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data

                  if(response.data.rb>0)
                  {
                     this.bubontop=true;
                  }else
                  {
                     this.bubontop=false;
                  }
                  
                    this.form = {

                          agent_name:item.agent_name,
                          regcode:item.regcode,
                          mem_pw:item.mem_pw,
                          mem_name:item.mem_name,
                          id:item.idx,
                          boss:item.boss,
                           admin_id:item.admin_id,
                          mem_id:item.mem_id,
                          event_loing_recom:item.event_loing_recom,
                          event_loing_recom_s:item.event_loing_recom_s,
                          event_loing_group_recom:item.event_loing_group_recom,
                          event_loing_group_recom_s:item.event_loing_group_recom_s,


                          event_loing_recom1:item.event_loing_recom1,
                          event_loing_recom_s1:item.event_loing_recom_s1,
                          event_loing_group_recom1:item.event_loing_group_recom1,
                          event_loing_group_recom_s1:item.event_loing_group_recom_s1,

                          event_loing_recom_e:item.event_loing_recom_e,
                          event_loing_recom_slot:item.event_loing_recom_slot,
                          mem_banknum:item.mem_banknum,
                          mem_bankcode:item.mem_bankcode,
                          mem_bankname:item.mem_bankname,
                          mem_jumin:item.mem_jumin,
                          mem_hp:item.mem_hp,
                          
                           
                          status:item.status,
                          pc_slot:item.pc_slot,
                          pc_e:item.pc_e,
                           pc_p:item.pc_p,
                          recy:item.recy
                         

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

          
           
          

        },
      
      searchEvent(){
        this.fetchManage()
      },
      shopClose(){
         this.$layer.close(this.layerid);
      },

      }
  }
</script>
<style scoped>

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 >>>.el-textarea__inner{
  height:33px;
 }
 >>>.el-form-item__label{
  text-align:left;
 }
</style>


// WEBPACK FOOTER //
// src/components/common/bon-edit.vue